import { round } from '@aytm/app/stats/lib/util/helpers'

import { CHART_VIEW_OPTIONS } from '@aytm/app/stats/page/question-views/sh/lib/constants'

export const getYAxisTitle = ({ viewMode, chartMode }) => {
  const base = CHART_VIEW_OPTIONS.find(v => v.value === viewMode)?.text || ''
  if (viewMode !== 'amount') return base
  return ['respondents', 'brespondents'].includes(chartMode) ? `${base} (respondents)` : `${base} (percents)`
}

export const getYAxisLimits = ({ viewMode, answerVariants, hcAnswers }) => {
  if (['amount', 'totalPickedUp'].includes(viewMode)) return false

  let min = 0
  let max = 0
  for (const av of answerVariants) {
    const amount = parseFloat(hcAnswers[`a${av.position}`]?.amount || 0)
    min = Math.min(min, amount)
    max = Math.max(max, amount)
  }

  min = min < 0 ? -Math.ceil(Math.abs(min)) : 0
  if (max <= 0 && min >= 0) max = 100
  else if (max <= 0) max = Math.ceil(Math.abs(min))
  else max = Math.ceil(max)

  if (min === max) return false
  return [round(min, 2), round(max, 2)]
}
